var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElementSafe } from '../../utils/custom_element';
import { CopyrightStyles } from './styles/notice';
/**
 * A copyright notice component that automatically updates the year
 * and includes a link to the privacy policy.
 *
 * @element copyright-notice
 */
let CopyrightNotice = class CopyrightNotice extends LitElement {
    /**
     * Renders the component template.
     */
    render() {
        const currentYear = new Date().getFullYear();
        return html `
      <div class="copyright-container">
        <span>&copy; ${currentYear} Diginova. All rights reserved.</span>
        <span class="separator">|</span>
        <a href="https://diginova.nl/privacy/">Privacy Policy</a>
      </div>
    `;
    }
};
/**
 * Defines the component's styles.
 */
CopyrightNotice.styles = CopyrightStyles;
CopyrightNotice = __decorate([
    customElementSafe('copyright-notice')
], CopyrightNotice);
export { CopyrightNotice };
